module.exports = __webpack_public_path__ + "static/media/s3_bucket.b6654f44.svg";